// src/App.tsx
import React from 'react';
import './App.css';
import SortingVisualizer from './SortingVisualiser';

function App() {
  return (
    <div className="App">
      <SortingVisualizer />
    </div>
  );
}

export default App;
